import theme from './theme.yaml'
import versions from './versions.yaml'

export default {
  theme,
  versions,
}
